import { render, staticRenderFns } from "./AdminIdeaPreviewPage.vue?vue&type=template&id=c602e354&scoped=true&"
import script from "./AdminIdeaPreviewPage.vue?vue&type=script&lang=ts&"
export * from "./AdminIdeaPreviewPage.vue?vue&type=script&lang=ts&"
import style0 from "./AdminIdeaPreviewPage.vue?vue&type=style&index=0&id=c602e354&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c602e354",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VIcon})
